import { AdminUpdateAssessmentStatusPayload, AdminUpdateAssessmentStatusResult } from "tech-health-assessment-sdk/dist";
import { api } from "../../../../../../../services/core-api-service";

class ChangeStatusDialogService {
    public async updateAssessmentStatus(assessmentId: string, payload: AdminUpdateAssessmentStatusPayload): Promise<AdminUpdateAssessmentStatusResult> {
        return api.admin.updateAssessmentStatus(assessmentId, payload)
    }
}

export const service = new ChangeStatusDialogService()